export enum TabIndex {
  OVERVIEW = 'overview',
  PERSONALIZED_ENGAGEMENT = 'personalized-engagement',
  ENGAGEMENT = 'engagement',
  SCIENTIFIC_INFORMATION = 'scientific-information',
  PARTNER_SCORE = 'partner-score',
  SEGMENTATION = 'segmentation',
  INSIGHT = 'insight',
}

export enum HcpSection {
  OVERVIEW = 'overview',
  PERSONALIZED_ENGAGEMENT = 'personalized-engagement',
  ENGAGEMENT = 'engagement',
  SCIENTIFIC_INFORMATION = 'scientific-information',
  PARTNER_SCORE = 'partner-score',
  SEGMENTATION = 'segmentation',
  INSIGHT = 'insight',
}
export type HcpSectionType = `${HcpSection}`;

export const VOC_SURVEY_RESPONSES_SECTION_ID = 'satisfactionAndSurveyResponses';

export type Tab = {
  label: string;
  param: HcpSection;
  shouldTabBeBlocked: boolean;
};

export const TABS: Tab[] = [
  { label: 'main.hcpOverview.tabMenu.overview', param: HcpSection.OVERVIEW, shouldTabBeBlocked: false },
  {
    label: 'main.hcpOverview.tabMenu.personalizedEngagement',
    param: HcpSection.PERSONALIZED_ENGAGEMENT,
    shouldTabBeBlocked: true,
  },
  { label: 'main.hcpOverview.tabMenu.hcpEngagement', param: HcpSection.ENGAGEMENT, shouldTabBeBlocked: false },
  {
    label: 'main.hcpOverview.tabMenu.scientificInformation',
    param: HcpSection.SCIENTIFIC_INFORMATION,
    shouldTabBeBlocked: true,
  },
  { label: 'main.hcpOverview.tabMenu.partnerScore', param: HcpSection.PARTNER_SCORE, shouldTabBeBlocked: true },
  { label: 'main.hcpOverview.tabMenu.segmentation', param: HcpSection.SEGMENTATION, shouldTabBeBlocked: false },
  { label: 'main.hcpOverview.tabMenu.insight', param: HcpSection.INSIGHT, shouldTabBeBlocked: true },
];

export const conditionalDisabledTabs = {
  PARTNER_SCORE: HcpSection.PARTNER_SCORE,
  INSIGHT: HcpSection.INSIGHT,
  SEGMENTATION: HcpSection.SEGMENTATION,
  HCP_ENGAGEMENT: HcpSection.ENGAGEMENT,
  PERSONALIZED_ENGAGEMENT: HcpSection.PERSONALIZED_ENGAGEMENT,
  SCIENTIFIC_INFORMATION: HcpSection.SCIENTIFIC_INFORMATION,
};
